import axios from 'axios';

export const axios_instance = axios.create( {
	headers: {
		'X-CSRF-Token': window.csrfToken
	}
} );
